import { Link } from "react-router-dom";
import type { Product } from "@/mocks/products";

interface ProductCardProps {
  product: Product;
}

export default function ProductCard({ product }: ProductCardProps) {
  return (
    <Link
      to={`/products/${product.id}`}
      className="group block cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative h-56 w-full overflow-hidden bg-secondary-100 md:h-64">
        <img
          src={product.image}
          alt={`${product.name} ${product.category} 석재`}
          title={`${product.name} 동우스톤 ${product.category}`}
          className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
          loading="lazy"
        />
        <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-3 py-1 font-label text-[11px] font-medium text-foreground-800 backdrop-blur-sm">
          {product.category}
        </span>
      </div>
      <div className="p-4 md:p-5">
        <p className="font-label text-[11px] tracking-[0.18em] text-primary-600">{product.nameEn}</p>
        <h3 className="mt-1.5 font-heading text-lg text-foreground-950">{product.name}</h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{product.summary}</p>
        <div className="mt-4 flex items-center gap-4 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-map-pin-line text-sm" />
            {product.origin}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-ruler-2-line text-sm" />
            {product.thickness.split("/")[0].trim()}
          </span>
        </div>
      </div>
    </Link>
  );
}